import React, { useEffect, useRef, useState } from "react";
import { Box, Tooltip, Typography } from "@mui/material";

const EllipsisTooltipCell = ({ text }) => {
  const textRef = useRef(null);
  const [isOverflow, setIsOverflow] = useState(false);

  useEffect(() => {
    const element = textRef.current;
    if (element) {
      setIsOverflow(element.scrollWidth > element.clientWidth);
    }
  }, [text]);

  return (
    <Tooltip
      title={
        isOverflow ? (
          <Typography sx={{ whiteSpace: "normal" }}>{text || "-"}</Typography>
        ) : ""
      }
      disableHoverListener={!isOverflow}
      arrow
    >
      <Box
        ref={textRef}
        sx={{
          width: "100%",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {text || "-"}
      </Box>
    </Tooltip>
  );
};

export default EllipsisTooltipCell;
